import React, { useEffect } from "react";
import '../App.css';
import item1 from "../assets/talent/icon1.svg";
import item2 from "../assets/talent/icon2.svg";
import item3 from "../assets/talent/icon3.svg";
import item4 from "../assets/talent/icon4.svg";
import item5 from "../assets/talent/icon5.svg";
import item6 from "../assets/talent/icon6.svg";
import item7 from "../assets/talent/item7.svg";
import item8 from "../assets/talent/item8.svg";
import Footer from "../components/footer/Footer";
import HeroImg from "../assets/about/hero-img.svg";
import mission1 from "../assets/about/mission-1.svg";
import mission2 from "../assets/about/mission-2.svg";
import product1 from "../assets/celebration/item-1.svg";
import product2 from "../assets/celebration/item-2.svg";
import product3 from "../assets/celebration/item-3.svg";
import product4 from "../assets/celebration/item-4.svg";
import product5 from "../assets/celebration/item-5.svg";
import product6 from "../assets/celebration/item-6.svg";
import product7 from "../assets/celebration/item-7.svg";
import product8 from "../assets/celebration/item-8.svg";
import product9 from "../assets/celebration/item-9.svg";
import product10 from "../assets/celebration/item-10.svg";
import product11 from "../assets/celebration/item-11.svg";
import product12 from "../assets/celebration/item-12.svg";
import product13 from "../assets/celebration/item-13.svg";
import product14 from "../assets/celebration/item-14.svg";
import product15 from "../assets/celebration/item-15.svg";
import productM1 from "../assets/celebration/item-m1.svg";
import productM2 from "../assets/celebration/item-m2.svg";
import productM3 from "../assets/celebration/item-m3.svg";
import productM4 from "../assets/celebration/item-m4.svg";
import productM5 from "../assets/celebration/item-m5.svg";
import productM6 from "../assets/celebration/item-m6.svg";
import productM7 from "../assets/celebration/item-m7.svg";
import productM8 from "../assets/celebration/item-m8.svg";
import productM9 from "../assets/celebration/item-m9.svg";
import productM10 from "../assets/celebration/item-m10.svg";
import productM11 from "../assets/celebration/item-m11.svg";
import productM12 from "../assets/celebration/item-m12.svg";
import productM13 from "../assets/celebration/item-m13.svg";
import productM14 from "../assets/celebration/item-m14.svg";
import productM15 from "../assets/celebration/item-m15.svg";
import ourLogo1 from "../assets/our/our-1.svg";
import ourLogo2 from "../assets/our/our-2.svg";
import ourLogo3 from "../assets/our/our-3.svg";
import ourLogo4 from "../assets/our/our-4.svg";
import ourLogo5 from "../assets/our/our-5.svg";
import { Grid } from "@mui/material";
import Slider from "react-slick";
import AboutHeader from "../components/header/AboutHeader";

function TalentCard({ addMargin, img, title, text1, text2, imgBg, text3 }) {
  return (
    <>
      <div className="job-seeker-card" style={{ marginRight: addMargin }}>
        <img src={img} className={`img-fluid ${imgBg}`} alt="" />
        <div>
          <h6 className="job-card-title">{title}</h6>
          <ul className="job-detail">
            <li>{text1}</li>
            <li>{text2}</li>
            <li>{text3}</li>
          </ul>
        </div>
      </div>
    </>
  );
}
function TalentCard1({ img, title, text1, text2, imgBg, text3, addMargin }) {
  return (
    <>
      {/* <div className="col-6 p-0"> */}
      <div className="job-seeker-card" style={{ marginRight: addMargin }}>
        <img src={img} className={`img-fluid ${imgBg}`} alt="" />
        <div>
          <h6 className="job-card-title">{title}</h6>
          <ul className="job-detail">
            <li>{text1}</li>
            <li>{text2}</li>
            <li>{text3}</li>
          </ul>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

function AboutPage() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    centerMode: true,
    arrows: false,
    centerPadding: "18%",
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "24%",
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "20%",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "18%",
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "16%",
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "15%",
        },
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "11%",
        },
      },
      {
        breakpoint: 330,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "6%",
        },
      },
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "4%",
        },
      },
    ],
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  },[])
  return (
    <>
       <AboutHeader title="About Us" />
      <section className="about-page">
        <div className="about-hero">
          <img src={HeroImg} className="hero-img" alt="" />
          <div>
            <h1 className="about-page-title">
              "Recruitifie: The Talent Matchmakers!"
            </h1>
            <p className="about-page-text">
              Recruitifie is an end-to-end recruiting platform that is
              revolutionizing the recruiting industry. It is a feature-rich
              recruitment platform for both job seekers and recruiters
            </p>
          </div>
        </div>
      </section>
      <section className="mission-section">
        <div className="mission-container">
          <div className="mission-card">
            <img src={mission1} alt="" />
            <div className="mission-card-content">
              <h6 className="mission-card-title">Mission</h6>
              <p className="mission-card-text">
                To connect top talent with the best job opportunities while
                providing an efficient and seamless hiring experience for
                companies.
              </p>
            </div>
          </div>
          <div className="mission-card">
            <img src={mission2} alt="" />
            <div className="mission-card-content">
              <h6 className="mission-card-title">Vision</h6>
              <p className="mission-card-text">
                To revolutionize the way companies find and hire talent by
                leveraging the latest technology and innovative recruiting
                strategies. <br />
                We strive to become the go-to platform for both job seekers and
                companies looking to hire top talent.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="recruiter-section">
        <div className="recruiter-about-container">
          <h6 className="recruiter-title">Job Seeker</h6>
          <div className="job-card-box">
            <div className="job">
              <TalentCard
                title="Application Tracking"
                img={item1}
                imgBg="bg-yellow"
                text1="Stay updated, organized, succeed."
                text2="Real-time updates, centralized management."
                text3="Maximize dream job chances."
              />
              <TalentCard
                title="Up Skill"
                img={item2}
                imgBg="bg-yellow"
                text1="Streamlined ATS: Simplify application management."
                text2="Centralize and organize candidate profiles."
                text3="Securely review and filter candidates."
              />
            </div>
            <div className="job">
              <TalentCard
                title="Career Counselling"
                img={item3}
                imgBg="bg-yellow"
                text1="Advanced matching: Comprehensive candidate profiles."
                text2="Machine learning, AI: Analyzing skills."
                text3="Holistic understanding: Candidate capabilities."
              />
              <TalentCard
                title="ATS- Friendly Resume Building"
                img={item4}
                imgBg="bg-yellow"
                text1="Customized hiring process: Recruitifie`s Automation."
                text2="Define stages, automate notifications."
                text3="Seamless workflow, efficient evaluations."
              />
            </div>
          </div>
        </div>
        <div className="recruiter-about-container">
          <div className="mobile-show-hide">
            <h6 className="recruiter-title">Recruiter</h6>
          </div>
          <div className="job-card-box">
            <div className="job">
              <TalentCard1
                title="Hiring Analysis"
                img={item5}
                imgBg="bg-blue"
                text1="Powerful analytics, valuable insights: Recruitifie."
                text2="Optimize hiring process with data."
                text3="Track metrics, make informed decisions. "
              />
              <TalentCard1
                title="Inbuilt ATS"
                img={item6}
                imgBg="bg-blue"
                text1="Streamlined ATS: Simplify application management."
                text2="Centralize and organize candidate profiles."
                text3="Securely review and filter candidates."
              />
            </div>
            <div className="job">
              <TalentCard1
                title="Advance Matching Algorithim"
                img={item7}
                imgBg="bg-blue"
                text1="Advanced matching: Comprehensive candidate profiles."
                text2="Machine learning, AI: Analyzing skills."
                text3="Holistic understanding: Candidate capabilities."
              />
              <TalentCard1
                title="Work Flow Automation"
                img={item8}
                imgBg="bg-blue"
                text1="Customized hiring process: Recruitifie`s Automation."
                text2="Define stages, automate notifications."
                text3="Seamless workflow, efficient evaluations."
              />
            </div>
          </div>
          <div className="desktop-show-hide">
            <h6 className="recruiter-title">Recruiter</h6>
          </div>
        </div>
      </section>
      <section className="our-about-section">
        <div className="mobile-show-hide">
          <h6 className="our-title">Our Partners</h6>
          <Slider {...settings}>
            <div>
              <div className="hiring-box">
                <h6 className="m-0 hiring-title">HIring Partners</h6>
                <div
                  className="d-flex"
                  style={{ gap: "8px", flexWrap: "wrap" }}
                >
                  <img
                    src={ourLogo1}
                    style={{
                      width: "104px",
                      objectFit: "cover",
                      height: "68px",
                    }}
                    alt=""
                  />
                  <img
                    src={ourLogo2}
                    style={{
                      width: "104px",
                      objectFit: "cover",
                      height: "68px",
                    }}
                    alt=""
                  />
                  <img
                    src={ourLogo3}
                    style={{
                      width: "104px",
                      objectFit: "cover",
                      height: "68px",
                    }}
                    alt=""
                  />
                  <img
                    src={ourLogo4}
                    style={{
                      width: "104px",
                      objectFit: "cover",
                      height: "68px",
                    }}
                    alt=""
                  />
                  <img
                    src={ourLogo4}
                    style={{
                      width: "104px",
                      objectFit: "cover",
                      height: "68px",
                    }}
                    alt=""
                  />
                  <img
                    src={ourLogo4}
                    style={{
                      width: "104px",
                      objectFit: "cover",
                      height: "68px",
                    }}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="know-box">
                <h6 className="m-0 know-title">KNowledge Partners</h6>
                <div
                  className="d-flex"
                  style={{ gap: "8px", flexWrap: "wrap" }}
                >
                  <img
                    src={ourLogo1}
                    style={{
                      width: "104px",
                      objectFit: "cover",
                      height: "68px",
                    }}
                    alt=""
                  />
                  <img
                    src={ourLogo1}
                    style={{
                      width: "104px",
                      objectFit: "cover",
                      height: "68px",
                    }}
                    alt=""
                  />
                  <img
                    src={ourLogo4}
                    style={{
                      width: "104px",
                      objectFit: "cover",
                      height: "68px",
                    }}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="tech-box">
                <h6 className="m-0 tech-title">Tech Partners</h6>
                <div
                  className="d-flex"
                  style={{ gap: "8px", flexWrap: "wrap" }}
                >
                  <img
                    src={ourLogo5}
                    style={{
                      width: "104px",
                      objectFit: "cover",
                      height: "68px",
                    }}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </Slider>
        </div>
        <div className="desktop-show-hide">
          <h6 className="our-title">Our Partners</h6>
          <div className="our-about-box">
            <div className="hiring-box">
              <h6 className="m-0 hiring-title">HIring Partners</h6>
              <div className="d-flex" style={{ gap: "16px", flexWrap: "wrap" }}>
                <img src={ourLogo1} alt="" />
                <img src={ourLogo2} alt="" />
                <img src={ourLogo3} alt="" />
                <img src={ourLogo4} alt="" />
                <img src={ourLogo4} alt="" />
                <img src={ourLogo4} alt="" />
              </div>
            </div>
            <div className="know-box">
              <h6 className="m-0 know-title">KNowledge Partners</h6>
              <div className="d-flex" style={{ gap: "16px", flexWrap: "wrap" }}>
                <img src={ourLogo1} alt="" />
                <img src={ourLogo1} alt="" />
                <img src={ourLogo4} alt="" />
              </div>
            </div>
            <div className="tech-box">
              <h6 className="m-0 tech-title">Tech Partners</h6>
              <div className="d-flex" style={{ gap: "16px", flexWrap: "wrap" }}>
                <img src={ourLogo5} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="celebration-section">
        <div className="container">
          <h2 className="celebration-title">Celebrating Excellence</h2>
          <p className="celebration-text m-0">Our Awards and Recognition</p>
          <div className="mobile-show-hide">
            <div className="celebration-box ">
              <Grid container justifyContent={"center"} columnGap={"16px"}>
                <Grid item xs={3}>
                  <img src={productM1} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM2} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM3} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM4} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM5} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM6} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM7} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM8} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM9} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM10} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM11} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM12} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM13} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM14} alt="" />
                </Grid>
                <Grid item xs={3}>
                  <img src={productM15} alt="" />
                </Grid>
              </Grid>
              {/* <div className="row">
                <div className="col d-flex justify-content-center">
                  <img src={product1} alt="" />
                </div>
                <div className="col d-flex justify-content-center">
                  <img src={product2} alt="" />
                </div>
                <div className="col d-flex justify-content-center">
                  <img src={product3} alt="" />
                </div>
              </div> */}
            </div>
            {/* <div className="celebration-box ">
              <div className="row">
                <div className="col d-flex justify-content-center">
                  <img src={product4} alt="" />
                </div>
                <div className="col d-flex justify-content-center">
                  <img src={product5} alt="" />
                </div>
                <div className="col d-flex justify-content-center">
                  <img src={product6} alt="" />
                </div>
              </div>
            </div>
            <div className="celebration-box ">
              <div className="row">
                <div className="col d-flex justify-content-center">
                  <img src={product7} alt="" />
                </div>
                <div className="col d-flex justify-content-center">
                  <img src={product8} alt="" />
                </div>
                <div className="col d-flex justify-content-center">
                  <img src={product9} alt="" />
                </div>
              </div>
            </div> */}
            {/* <div className="celebration-box ">
              <div className="row">
                <div className="col d-flex justify-content-center">
                  <img src={product10} alt="" />
                </div>
                <div className="col d-flex justify-content-center">
                  <img src={product11} alt="" />
                </div>
                <div className="col d-flex justify-content-center">
                  <img src={product12} alt="" />
                </div>
              </div>
            </div>
            <div className="celebration-box ">
              <div className="row">
                <div className="col d-flex justify-content-center">
                  <img src={product13} alt="" />
                </div>
                <div className="col d-flex justify-content-center">
                  <img src={product14} alt="" />
                </div>
                <div className="col d-flex justify-content-center">
                  <img src={product15} alt="" />
                </div>
              </div>
            </div> */}
          </div>
          {/* Desktop View */}
          <div className="desktop-show-hide">
            <div className="celebration-box ">
              <Grid
                container
                justifyContent={"center"}
                columnGap={"50px"}
                columns={{ md: 12 }}
              >
                <Grid item lg={2}>
                  <img src={product1} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product2} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product3} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product4} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product5} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product6} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product7} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product8} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product9} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product10} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product11} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product12} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product13} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product14} alt="" />
                </Grid>
                <Grid item lg={2}>
                  <img src={product15} alt="" />
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default AboutPage;
